import gql from 'graphql-tag';

export const UPDATE_ARTICLE_GROUP_MUTATION = gql`
  mutation UpdateArticleGroupMutation($articleGroupInput: ArticleGroupInput!) {
    updateArticleGroup(articleGroupInput: $articleGroupInput) {
      errors
    }
  }
`;
